/**
 * Application configuration
 * Replaces WordPress-injected globals (MECGRUPPEN_SETTINGS, jinkosoft_app_data)
 */

// Parse languages from env
let languages = {}
try {
    languages = JSON.parse(import.meta.env.VITE_AVAILABLE_LANGUAGES || '{}')
} catch (e) {
    console.error('Failed to parse VITE_AVAILABLE_LANGUAGES:', e)
    languages = {
        en: { id: 1, code: 'en', name: 'English' }
    }
}

// jinkosoft_app_data equivalent
export const jinkosoft_app_data = {
    languages,
    selected_language: import.meta.env.VITE_DEFAULT_LANGUAGE || 'en',
    is_logged_in: !!localStorage.getItem(import.meta.env.VITE_JWT_STORAGE_KEY || 'auth_token'),
    admin_username: localStorage.getItem('admin_username') || 'Admin'
}

window.jinkosoft_app_data = jinkosoft_app_data